// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-ordering-container {
  padding: 20px;
  background-color: #f5f7fb;
  min-height: 100vh;
}

.table-ordering-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.header-left h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1a202c;
}

.table-ordering-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 2px solid #e2e8f0;
}

.tab-button {
  padding: 12px 24px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 16px;
  font-weight: 500;
  color: #718096;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-button.active {
  color: #2196f3;
  border-bottom-color: #2196f3;
  background-color: #f0f8ff;
}

.table-ordering-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

/* Table Pins Section */
.pins-table-container {
  overflow-x: auto;
}
.pins-table {
  width: 100%;
  border-collapse: collapse;
}
.pins-table th {
  padding: 12px;
  text-align: left;
  background: #f8fafc;
  color: #4a5568;
  border-bottom: 2px solid #edf2f7;
  font-size: 14px;
}
.pins-table td {
  padding: 16px 12px;
  border-bottom: 1px solid #edf2f7;
  font-size: 14px;
}
.pin-code-cell {
  font-family: monospace;
  font-weight: 700;
  color: #2196f3;
  background: #e3f2fd;
  padding: 4px 10px;
  border-radius: 4px;
}
.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}
.status-active {
  background: #def7ec;
  color: #03543f;
}
.status-closed {
  background: #fde8e8;
  color: #9b1c1c;
}
.active-indicator.active {
  color: #057a55;
  font-weight: 600;
}

/* Pins Filter Row */
.pins-filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.pins-filter-row .task-filter-buttons {
  margin-bottom: 0;
}

.pin-search-input {
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-size: 14px;
  color: #1a202c;
  outline: none;
  width: 240px;
  transition: border-color 0.2s ease;
}

.pin-search-input:focus {
  border-color: #2196f3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.15);
}

.pin-search-input::placeholder {
  color: #a0aec0;
}

/* Waiter Tasks Grid UI */
.task-filter-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
}
.filter-button {
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  cursor: pointer;
  color: #4a5568;
  font-weight: 500;
}
.filter-button.active {
  background: #2196f3;
  color: white;
  border-color: #2196f3;
}

.tasks-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 20px;
}

.table-group-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.table-group-card:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.table-group-header {
  padding: 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-info h3 {
  margin: 0;
  font-size: 18px;
  color: #1e293b;
}
.table-info span {
  font-size: 12px;
  color: #64748b;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.complete-all-btn {
  background: #ffffff;
  color: #057a55;
  border: 1px solid #057a55;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.complete-all-btn:hover {
  background: #f3faf7;
}

.task-count-badge {
  background: #2196f3;
  color: white;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.table-tasks-list {
  padding: 8px;
}

.individual-task-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  border-bottom: 1px solid #f1f5f9;
}

.mini-task-icon {
  font-size: 20px;
  flex-shrink: 0;
}
.task-item-content {
  flex: 1;
}
.task-item-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.task-item-main strong {
  font-size: 14px;
  color: #334155;
}
.task-item-time {
  font-size: 11px;
  color: #94a3b8;
}
.task-item-desc {
  font-size: 13px;
  color: #64748b;
  margin: 2px 0 0 0;
}
.done-by {
  color: #057a55;
  font-weight: 600;
  display: block;
  margin-top: 4px;
  font-size: 11px;
}

.approve-mini-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: #f0fdf4;
  color: #16a34a;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.approve-mini-btn:hover {
  background: #16a34a;
  color: white;
}
.check-icon-small {
  width: 20px;
  height: 20px;
  stroke-width: 2.5;
}

/* Pagination Shared */
.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.pagination-info {
  font-size: 13px;
  color: #718096;
}
.pagination-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
}
.page-indicator {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
}

.loading-state,
.empty-state {
  padding: 60px;
  text-align: center;
  color: #94a3b8;
}

@media (max-width: 768px) {
  .tasks-grid {
    grid-template-columns: 1fr;
  }
  .table-group-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .header-actions {
    width: 100%;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-ordering/TableOrdering.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF","sourcesContent":[".table-ordering-container {\n  padding: 20px;\n  background-color: #f5f7fb;\n  min-height: 100vh;\n}\n\n.table-ordering-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.header-left h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.table-ordering-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.tab-button {\n  padding: 12px 24px;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  font-size: 16px;\n  font-weight: 500;\n  color: #718096;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tab-button.active {\n  color: #2196f3;\n  border-bottom-color: #2196f3;\n  background-color: #f0f8ff;\n}\n\n.table-ordering-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  padding: 24px;\n}\n\n/* Table Pins Section */\n.pins-table-container {\n  overflow-x: auto;\n}\n.pins-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.pins-table th {\n  padding: 12px;\n  text-align: left;\n  background: #f8fafc;\n  color: #4a5568;\n  border-bottom: 2px solid #edf2f7;\n  font-size: 14px;\n}\n.pins-table td {\n  padding: 16px 12px;\n  border-bottom: 1px solid #edf2f7;\n  font-size: 14px;\n}\n.pin-code-cell {\n  font-family: monospace;\n  font-weight: 700;\n  color: #2196f3;\n  background: #e3f2fd;\n  padding: 4px 10px;\n  border-radius: 4px;\n}\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n.status-active {\n  background: #def7ec;\n  color: #03543f;\n}\n.status-closed {\n  background: #fde8e8;\n  color: #9b1c1c;\n}\n.active-indicator.active {\n  color: #057a55;\n  font-weight: 600;\n}\n\n/* Pins Filter Row */\n.pins-filter-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.pins-filter-row .task-filter-buttons {\n  margin-bottom: 0;\n}\n\n.pin-search-input {\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  font-size: 14px;\n  color: #1a202c;\n  outline: none;\n  width: 240px;\n  transition: border-color 0.2s ease;\n}\n\n.pin-search-input:focus {\n  border-color: #2196f3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.15);\n}\n\n.pin-search-input::placeholder {\n  color: #a0aec0;\n}\n\n/* Waiter Tasks Grid UI */\n.task-filter-buttons {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n.filter-button {\n  padding: 10px 20px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  cursor: pointer;\n  color: #4a5568;\n  font-weight: 500;\n}\n.filter-button.active {\n  background: #2196f3;\n  color: white;\n  border-color: #2196f3;\n}\n\n.tasks-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n  gap: 20px;\n}\n\n.table-group-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden;\n  transition: box-shadow 0.3s ease;\n}\n\n.table-group-card:hover {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.table-group-header {\n  padding: 16px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.table-info h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #1e293b;\n}\n.table-info span {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.complete-all-btn {\n  background: #ffffff;\n  color: #057a55;\n  border: 1px solid #057a55;\n  padding: 5px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.complete-all-btn:hover {\n  background: #f3faf7;\n}\n\n.task-count-badge {\n  background: #2196f3;\n  color: white;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.table-tasks-list {\n  padding: 8px;\n}\n\n.individual-task-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 8px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.mini-task-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n.task-item-content {\n  flex: 1;\n}\n.task-item-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.task-item-main strong {\n  font-size: 14px;\n  color: #334155;\n}\n.task-item-time {\n  font-size: 11px;\n  color: #94a3b8;\n}\n.task-item-desc {\n  font-size: 13px;\n  color: #64748b;\n  margin: 2px 0 0 0;\n}\n.done-by {\n  color: #057a55;\n  font-weight: 600;\n  display: block;\n  margin-top: 4px;\n  font-size: 11px;\n}\n\n.approve-mini-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: none;\n  background: #f0fdf4;\n  color: #16a34a;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.approve-mini-btn:hover {\n  background: #16a34a;\n  color: white;\n}\n.check-icon-small {\n  width: 20px;\n  height: 20px;\n  stroke-width: 2.5;\n}\n\n/* Pagination Shared */\n.pagination-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.pagination-info {\n  font-size: 13px;\n  color: #718096;\n}\n.pagination-buttons {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.page-indicator {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.loading-state,\n.empty-state {\n  padding: 60px;\n  text-align: center;\n  color: #94a3b8;\n}\n\n@media (max-width: 768px) {\n  .tasks-grid {\n    grid-template-columns: 1fr;\n  }\n  .table-group-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  .header-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
